module.exports = __webpack_public_path__ + "img/Residencial Bunaglow- Kankavali.066d160d.jpg";